import React from "react";

import { FullContainerMediaBlock as Value } from "@reactivated";

import { Themed } from "../../styles/themes";
import { MediaChooserBlock, getMediaAspectRatio } from "../MediaChooserBlock";

import styles from "./index.module.scss";

export const FullContainerMediaBlock = ({ value }: { value: Value }) => {
    if (!value.media || value.media.length === 0) return <></>;

    const aspectRatio = getMediaAspectRatio(value.media);

    return (
        <Themed theme={value.theme} tag="section">
            <div className={styles.container}>
                <div
                    className={styles.stage}
                    style={
                        aspectRatio
                            ? { "--media-aspect-ratio": aspectRatio }
                            : undefined
                    }
                >
                    <div className={styles.mediaSizer}>
                        <MediaChooserBlock
                            value={value.media}
                            wrapperAttrs={{ className: styles.media }}
                        />
                    </div>
                </div>
            </div>
        </Themed>
    );
};
